export const NAVBAR_BLOCK_s12 = {
  "blockType": "NAVBAR",
  "blockDesign": "NavDesign1",
  "editFormName": "NAVBAR_FORM_1",
  "styleProps": {
    "background-color": "#0E0F10"
  },
  "logoType": "text",
  "logoImg": {
    "src": "https://freshflowxyz.b-cdn.net/assets/logo/FlexBee-Logo-1.jpg",
    "altText": "FlexBee",
    "styleProps": {
      "height": "3rem"
    }
  },
  "logoText": {
    "text": "✨Gonic",
    "styleProps": {
      "font-size": "1.875rem",
      "color": "#ffffff",
      "font-family": "'Old Standard TT'",
      "line-height": "2.25rem",
      "font-family-bk": "'Lato', sans-serif",
      "font-weight": "900",
      "font-family-cust": " Old Standard TT"
    },
    "stylePropsMob": {},
    "stylePropsTab": {}
  },
  "logoHTML": {
    "html": "FlexBee",
    "styleProps": {
      "font-size": "1.875rem",
      "color": "#ffffff",
      "font-family": "'Oswald', sans-serif",
      "line-height": "2.25rem"
    },
    "stylePropsMob": {},
    "stylePropsTab": {}
  },
  "links": [
    {
      "text": "Features",
      "linkUrl": "/features",
      "styleProps": {
        "color": ""
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "Services",
      "linkUrl": "/services",
      "styleProps": {
        "color": ""
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "Docs",
      "linkUrl": "/docs",
      "styleProps": {
        "color": ""
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "Blog",
      "linkUrl": "/home",
      "sectionID": "aboutsection",
      "styleProps": {
        "color": "",
        "margin": "0px 0px 0px 120px"
      }
    },
    {
      "text": "Get Started",
      "linkUrl": "/home",
      "sectionID": "aboutsection",
      "styleProps": {
        "color": "#333333",
        "border-width": "0px",
        "border-radius": "9999px",
        "padding": "14px 30px 14px 30px",
        "margin": "0px 0px 0px 20px",
        "border-color": "#4f4f4f",
        "background-color": "#E5BCE6"
      }
    }
  ],
  "hamburgerStyleProps": {
    "color": "#ffffff",
    "border-color": "#ffffff"
  },
  "metaDataId": 1746279031769,
  "afterIndex": 8,
  "blockId": 1746279031769,
  "linksStyleProps": {
    "color": "#808080",
    "padding": "14px 0px 14px 0px",
    "font-weight": "600",
    "font-size": "1rem",
    "line-height": "1.5rem"
  },
  "fonts": {
    "logoText": " Old Standard TT"
  }
}